import React, { Fragment, useEffect, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import RateRender from "../../../../Common/RateRender";
import { useDispatch, useSelector } from "react-redux";
import "../../index.css";
import { Get } from "../../../../../Request";
import { BsRecord2 } from "react-icons/bs";
export const CardInfo = ({ Item, itemId, favorite_status }) => {
  const initialState = {
    loading: false,
    favorite_status: favorite_status,
    data: {
      rel_id: itemId,
      rel_type: "item",
    },
  };
  const { user, favorites } = useSelector(state => state);
  const dispatch = useDispatch();

  const handler = list => {
    dispatch({ type: "SET", payload: { favorites: list } });
  };

  return (
    <div
      className="rg-info p-4"
      style={{
        boxShadow: "0px 1px 6px -2px #333",
      }}
    >
      <div className="rg-gymname">{Item.name}</div>

      <div className="ranks text-center">
        <RateRender data={Item.comments_avg_score} />
      </div>
      <div className="rg-gymaddress">
        <span className="fs-5 fw-bold ">آدرس : </span>
        <p className="py-2">
          استان : {Item.province[0] && Item.province[0].name}
          <br />
          شهر : {Item.city[0] && Item.city[0].name}
          <br />
          منطقه : {Item.region[0] && Item.region[0].name}
        </p>
        <p>{Item.details && Item.details.address}</p>
      </div>
      <div className="row justify-content-center">
        <div className="col-auto text-center">
          {/* <FavoriteComponent id={itemId} list={favorites} method={handler} /> */}
        </div>
      </div>
    </div>
  );
};

export const Image = ({ data, alt = [], name }) => {
  const initialState = {
    loading: true,
    data: data,
    img: data && data[0],
  };
  const [state, setstate] = useState(initialState);

  useEffect(() => {
    console.log(state.img);
  }, [state])


  const renderAlt = i => {
    if (alt && Array.isArray(alt) && alt.length > 0) {
      return alt[i] ? alt[i] : `${name} رزرو مجموعه ی`;
    }
    return `مجموعه ${name}`;
  };
  return (
    <Fragment>
      <div
        className="col-lg-2 me-2  resg-direct-box"
        style={{ width: "unset" }}
      ></div>

      <div className="card shadow-sm mt-2">
        <img
          src={state.img}
          alt={renderAlt(1)}
          className="img-fluid rounded-3"
          style={{ objectFit: "cover" }}
        />

        <div className="resg-img-card-hover">
          <div className="resg-img-logo"></div>
        </div>
      </div>
      <div className="row justify-content-between text-center pt-2 px-1 ">
        <div className="px-0">
          <Splide
            className=""
            options={{
              direction: "rtl",
              gap: "0.7rem",
              perPage: 6,
              perMove: 1,
              pagination: false,
              arrows: false,
              breakpoints: {
                1400: {
                  perPage: 5,
                },
                576: {
                  perPage: 4,
                },
                450: {
                  perPage: 3,
                },
                370: {
                  perPage: 2,
                },
              },
            }}
          >
            {state.data &&
              state.data.map((item, i) => {
                if (i < 8) {
                  return (
                    <SplideSlide key={i} className="splide__slide ">
                      <div
                        onClick={() =>
                          setstate({
                            ...state,
                            img: item,
                          })
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex flex-wrap mb-1">
                          {/* <div className="resg-direct-img"> */}
                          <img
                            alt={renderAlt(i)}
                            src={item}
                            className={"img-fluid rounded-3 " +
                              (state.img == item
                                ? "activeImg"
                                : "")}
                            style={{
                              objectFit: "fill",
                              width: "95",
                              height: "62.5px",
                            }}
                          />
                          {/* </div> */}
                        </div>
                      </div>
                    </SplideSlide>
                  );
                }
              })}
          </Splide>
        </div>
      </div>
    </Fragment>
  );
};

export const Information = ({ description, name, item, details }) => {
  const renderOembed = () => { };
  useEffect(() => {
    const oembed = document.querySelector("oembed");
    if (oembed) {
      const url = oembed.getAttribute("url");
      const div = document.createElement("div");
      const span = document.createElement("span");
      const iframe = document.createElement("iframe");
      const att = document.createAttribute("class");
      const spanClass = document.createAttribute("class");
      const iframeClass = document.createAttribute("class");
      const divClass = document.createAttribute("class");
      const src = document.createAttribute("src");
      src.value = `https://www.aparat.com/video/video/embed/videohash/${url.split("/v/")[1]
        }/vt/frame`;
      att.value = "h_iframe-aparat_embed_frame";
      spanClass.value = "span_lashi";
      iframeClass.value = "iframe-content";
      divClass.value = "iframe-container";

      div.setAttributeNode(att);
      span.setAttributeNode(spanClass);
      iframe.setAttributeNode(iframeClass);
      div.setAttributeNode(divClass);

      const allowFullScreen = document.createAttribute("allowFullScreen");
      allowFullScreen.value = true;
      const webkitallowfullscreen = document.createAttribute(
        "webkitallowfullscreen"
      );
      webkitallowfullscreen.value = true;
      const mozallowfullscreen = document.createAttribute("mozallowfullscreen");
      mozallowfullscreen.value = true;

      iframe.setAttributeNode(src);
      iframe.setAttributeNode(allowFullScreen);
      iframe.setAttributeNode(webkitallowfullscreen);
      iframe.setAttributeNode(mozallowfullscreen);
      div.appendChild(span);
      div.appendChild(iframe);
      window.$("oembed").after(div);
      oembed.remove();
    }
  }, []);

  return (
    <div ref={details}>
      {/* <div className="row">
        <div className="col-12">
          <h5 className="mb-4 pb-2" style={{ borderBottom: "1px solid #E42A3F", color: "#E42A3F" }}>
            <img
              src={window.origin + `/WebSide/assets/images/${98}.png`}
              alt="همه ملاقات"
              style={{
                width: "40px",
                height: "40px",
                marginLeft: "10px",
              }}
            />
            {`توضیحات ${item.name}`}
          </h5>
        </div>
      </div> */}
      <div
        className="content"
        style={{
          color: "#404040",
          textAlign: "justify",
          fontWeight: "400",
          p: {
            fontWeight: "400",
          },
        }}
        dangerouslySetInnerHTML={{
          __html: description,
          // `<style>.h_iframe-aparat_embed_frame{position:relative;}.h_iframe-aparat_embed_frame .ratio{display:block;width:100%;height:auto;}.h_iframe-aparat_embed_frame iframe{position:absolute;top:0;left:0;width:100%;height:100%;}</style><div class="h_iframe-aparat_embed_frame"><span style="display: block;padding-top: 57%"></span><iframe src="https://www.aparat.com/video/video/embed/videohash/0dIpk/vt/frame" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe></div>`,
        }}
      ></div>

    </div>
  );
};

export const Possibilities = ({ item, details }) => {

  return (
    <div ref={details}>
      {/* <div className="row">
        <div className="col-12">
          <h5 className="mb-4 pb-2" style={{ borderBottom: "1px solid #E42A3F", color: "#E42A3F" }}>
            <TbSitemap size={"30px"} className="me-2" />
            {`امکانات ${item.name}`}
          </h5>
        </div>
      </div> */}
      <div className="row">
        {item.itemoptins &&
          item.itemoptins.map((option, key) => {
            return (
              <div className="col-6 col-md-4 col-lg-3 mb-4" key={key}>
                <div className="d-flex align-items-center">
                  <img
                    src={window.origin + `/WebSide/assets/images/tickpool.png`}
                    alt="همه ملاقات"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginLeft: "10px",
                    }}
                  />
                  <h6
                    style={{
                      fontWeight: "400",
                      fontSize: "14px",
                    }}
                  >
                    {option.name}
                  </h6>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};


export const RefundList = ({prdId}) => {
  const [refundList, setRefundList] = useState();
  useEffect(() => {
    Get({ url: "/refundsetting/getall", data: { item_id: prdId } }).then(data => {
      setRefundList(data)
    });
  }, []);

  return (
    <Fragment>
      {refundList && refundList.length > 0
        ? refundList.map(item => (
          <div key={item.id} className="mb-3 ms-2">
            <BsRecord2 className="ml-2 me-2" />
            میزان کسری
            <span className="font-weight-bold">
              {" " + (item.remaining_time) + " "}
            </span>
            ساعت قبل از شروع  :
            <span className="font-weight-bold">
              {" " + (item.percentage) + " "}
              %
            </span>
          </div>
        ))
        : <div className="mb-2 mr-3">
          <BsRecord2 className="ml-2" />
          شرایطی برای استرداد ثبت نشده است
        </div>
      }
    </Fragment>
  )
}